import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { sweetAlert } from "../../../utils/swal";
import {
  downloadFile,
  downloadFileAsBlob,
  getArrayBuffer,
} from "src/app/utils/pdf-downloader";
import * as moment from "moment-timezone";
import { ActivatedRoute, Router } from "@angular/router";
import { urls } from "src/app/utils/url-utils";
import { SignaturePad } from "angular2-signaturepad";
import * as _ from "underscore";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { AssigTripsService } from "../../assigned-trips/assigntrips-service/assigntrips-service";
import { DispatchCenterService } from "../../dashboard/dashboard-service/dispatch-center-service";
import { FleetService } from "../../fleet/fleet-service/fleet.service";
import {
  PAYOR,
  checkRole,
  exportToCsv,
  getBillingBrokers,
  getBrokersList,
  urlToBase64,
} from "src/app/utils/utils.common";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { generatePdf, getCompanyLogo } from "src/app/utils/utils.common";
import { PDFDocument } from "pdf-lib";
import { isArray } from "util";
import { FormBuilder, FormGroup } from "@angular/forms";
import { FilterPipe } from "src/app/pipe/list-filter-pipe/list-filter-pipe";
import { FilterByKeyPipe } from "src/app/pipe/list-filterbykey-pipe/list-filterbykey-pipe";
import { ModivcareReportService } from "src/app/service/modivcare-report-service/modivcare-report.service";
import { CorporateService } from "../../corporate-user/corporate-service/corporate-service";
import { LevelOfServiceService } from "../../level-of-service/service/level-of-service.service";
import { UserRoles } from "../../shared/layout/menu-service/menu.service";
import { CsvService } from "src/app/service/csv-service/csv.service";
import { ReportService } from "../../reports/reports-service/report.service";
import { Cms1500Service } from "src/app/service/cms-service/cms1500.service";
import { CatServiceService } from "src/app/service/cat-service/cat-service.service";
import { DriverLogService } from "src/app/service/driver-log-service/driver-log.service";
import { MemberLogService } from "src/app/service/member-log-service/member-log.service";
import { environment } from "src/environments/environment";
import { CorporateReportService } from "src/app/service/corporate-report-service/corporate-report.service";
@Component({
  selector: "app-verified-trip-logs",
  templateUrl: "./verified-trip-logs.component.html",
  styleUrls: ["./verified-trip-logs.component.css"],
})
export class VerifiedTripLogsComponent
  implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;

  minDate;
  maxDate;
  // tslint:disable-next-line: ban-types
  public signaturePadOptions: Object = {
    // passed through to szimek/signature_pad constructor
    minWidth: 5,
    canvasWidth: 750,
    canvasHeight: 300,
  };


  status;
  user;
  timeZone;
  searchDate;
  dateRange;
  search = "";
  dataList = [];
  filteredAdjustedTrips = [];
  selectedTrips = [];
  selectedTripJobIds = [];
  brokers;
  // selectedBroker = "";

  drivers = [];
  members = [];
  selectedDriver = "";
  selectedMember = "";
  corporateUsers;
  selectedCorporateUser;
  isMedical = false;

  projectedOdometer = "";
  tempVin;
  odometerBegin;
  odometerStart;
  odometerStop;

  isOdometerRequest = false;
  isAllTripsSelected = false;

  popupAssignTrip: any;
  bankedType;

  jobType = "assigned";
  type = null;
  tempCompanyImage =
    "https://s3.amazonaws.com/neighborhood-dev/assets/brokers/MixandMatch.png";
  companyImage = this.tempCompanyImage;
  fleet;
  isShowFilter = false;
  odomterModalObj;
  signatureModalObj;

  preCorporate;
  preFleet;
  preLevelOfServices = {};
  preSpaceTypes = {};

  driverLoader = {
    isLoading: false,
  };

  modivcareTripLog = {
    isLoading: false
  }
  isTripLogLoader = {
    isLoading: false
  }
  isColoradoReport = {
  loader: false
  }

  trfLoader = {
    isLoading: false
  }
  coReportLoader = {
    isLoading: false
  };

  memberLoader = {
    isLoading: false,
  };
  paramountLoader = {
    isModal: false,
    isLoading: false
  };
  selectedCorporateId = '';
  view = "grid";
  alertMessage = "";
  orderBy = "scheduleTime";
  selectedDropdownIndex
  toggleActionButtons = false;
  isAllowRates: boolean = false;
  isAHCCCSFile = false;
  isProduction = environment.production;
  todayDate;
  corporateLoader = {
    isLoading: false,
  };
  isMemberTripsLogDownloading = false;
  isTripsLogHMTLoading = false;
  isMemberMBRloading = false;
  isMemberFile = false;


  constructor(
    private csvService: CsvService,
    private levelOfServiceService: LevelOfServiceService,
    private modivcareService: ModivcareReportService,
    private reportService: ReportService,
    private assignTripService: AssigTripsService,
    private fleetService: FleetService,
    private corporateService: CorporateService,
    private sharedDataService: SharedDataService,
    private cms1500Service: Cms1500Service,
    private router: Router,
    private catService : CatServiceService,
    private driverLogService : DriverLogService,
    private memberLogService: MemberLogService,
    private corporateReportService: CorporateReportService

  ) { }

  ngOnInit() {
    this.status = "adjustedtriplogs";
    this.brokers = getBillingBrokers;
    this.getUser();
    this.getCorporateUsers();
    this.getFleetList();
    this.getSpaceTypes();
    this.getLevelOfService();
  }

  ngAfterViewInit() {
    if (this.signaturePad) {
      // this.signaturePad is now available
      this.signaturePad.set("minWidth", 5); // set szimek/signature_pad options at runtime
      this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((user) => {
        if (user) {
          this.timeZone = user.timeZone;
          this.todayDate = moment.tz(this.timeZone).startOf('day').toISOString();
          this.user = user;
          // this.searchDate = moment().startOf('day').toISOString();
          this.searchDate = moment
            .tz(this.timeZone)
            .startOf("day")
            .toISOString();
          this.dateRange = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];

          this.minDate = moment.tz(this.timeZone).startOf("day").toISOString();
          this.maxDate = moment.tz(this.timeZone).add(1, 'month').startOf("day").toISOString();

          this.isAllowRates = checkRole(this.user);
          this.getAdjustedTrips();
        }


      });
  }

  getCorporateUsers() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateUsers = data;

          this.preCorporate = data.reduce(
            (obj, item) => ((obj[item._id] = item), obj),
            {}
          );

        }
      });
  }

  getCorporateByID(id) {
    return this.preCorporate[id];
  }

  getAdjustedTrips() {
    let queryParams = {
      status: this.status,
      // scheduleTime: this.searchDate,
      scheduleTime:  this.dateRange.toString(),
      jobType: this.jobType,
    };

    if (this.isMedical) {
      queryParams["isMedical"] = this.isMedical;
    }

    if (this.selectedCorporateId) {
      queryParams["cooperate"] = this.selectedCorporateId;
    }


    this.members = [];
    this.drivers = [];
    this.selectedTrips = [];
    this.filteredAdjustedTrips = [];
    this.dataList = [];

    this.search = "";
    this.selectedMember = "";
    this.selectedDriver = "";

    this.assignTripService
      .getAdjustedTripsList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.dataList = data;
          this.filteredAdjustedTrips = data;

          this.dataList.forEach((trip, i) => {
            const isFound = this.drivers.some(
              (driver) => driver._id === trip.driver._id
            );
            if (!isFound) {
              this.drivers.push(trip.driver);
            }
            this.members.push(trip.priorityClient);
          });

          this.members = _.uniq(this.members, (obj) => obj.displayName);
          this.group()
          this.filterTripsByModel();
        }
      });
  }

  onSearchDateChange(event) {
    this.searchDate = event.toISOString();
    this.getAdjustedTrips();
  }


  onDateRangeChange(event) {
    const duration = moment.duration(event[1].diff(event[0]));
    const diffInDays = duration.asMonths();
    if (diffInDays < 1) {
      this.dateRange = [
        event[0].toISOString(),
        event[1].endOf("day").toISOString(),
      ];
      this.getAdjustedTrips();
      return;
    }

    this.dateRange = [];
    sweetAlert("Error", 'You can only select a date range of up to 30 days.', "warning", "Ok");

  }

  onSelectCorporateUser() {
    if (this.selectedCorporateId) {
      this.selectedCorporateUser = this.preCorporate[this.selectedCorporateId];
      this.jobType = "cooperate";
      this.isMedical = false;

      this.getAdjustedTrips();
    } else {
      this.selectedCorporateId = "";
      this.selectedCorporateUser = null;
      this.jobType = "assigned";
      this.companyImage = this.tempCompanyImage;
      this.getAdjustedTrips();
    }

  }

  onSelectDriver() {
    this.filterTripsByModel();
    if (this.filteredAdjustedTrips.length) {
      const trip = this.filteredAdjustedTrips[0];
      if (trip && trip.fleet) {
        const fleetId = trip.fleet;
        this.projectedOdometer = null;
        this.fleetService
          .getFleetDataById(fleetId)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              this.fleet = data;
              // this.projectedOdometer = this.fleet[this.selectedBroker];
            }
          });
      }
    }
  }

  // Trip Selection Starts
  selectTrips(assign) {
    const index = this.selectedTrips.indexOf(assign._id);
    if (index > -1) {
      assign.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      assign.isSelected = true;
      this.selectedTrips.push(assign._id);
    }
  }

  selectAll() {

    this.filteredAdjustedTrips.forEach((assign) => {
      assign.isSelected = true;
      if (!this.selectedTrips.includes(assign._id))
        this.selectedTrips.push(assign._id);
    });

    this.isAllTripsSelected =
      this.selectedTrips.length === this.filteredAdjustedTrips.length;
    return this.isAllTripsSelected;
  }

  unSelectAllTrips() {
    const unselectedTrips = [];
    this.filteredAdjustedTrips.forEach((trip) => {
      trip.isSelected = false;
      unselectedTrips.push(trip._id);
    });
    this.selectedTrips = this.selectedTrips.filter(
      (x) => !unselectedTrips.includes(x)
    );
    this.isAllTripsSelected = false;
  }

  filterTripsByModel() {
    this.filteredAdjustedTrips = this.dataList;

    this.filteredAdjustedTrips = new FilterPipe().transform(
      this.filteredAdjustedTrips,
      this.search
    );

    this.filteredAdjustedTrips = new FilterByKeyPipe().transform(
      this.filteredAdjustedTrips,
      "assign.priorityClient.displayName",
      this.selectedMember
    );


    this.filteredAdjustedTrips = new FilterByKeyPipe().transform(
      this.filteredAdjustedTrips,
      "assign.driver._id",
      this.selectedDriver
    );
  }

  getSelectedTrips() {
    return this.dataList.filter((trip) => trip.isSelected);
  }

  adjustOdometer() {
    const payload = {
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      driver: this.selectedDriver,
      fleet: this.fleet._id,
      projectedOdometer: this.projectedOdometer,
      // companyType: this.selectedBroker,
    };
    this.assignTripService
      .adjustTripOdometer(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Updated Successfully', 'success', 'OK');
        }
      });
  }

  // OK
  nextOdometer() {
    const payload = {
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      driver: this.selectedDriver,
      fleet: this.fleet._id,
      projectedOdometer: this.projectedOdometer,
      // companyType: this.selectedBroker,
    };

    this.assignTripService
      .adjustAllTripsOdometer(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Updated Successfully', 'success', 'OK');
        }
      });
  }

  signatureUpdate(isSignature) {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      isSignature: isSignature,
    };

    this.assignTripService
      .signatureUpdate(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Signature Updated Successfully', 'success', 'OK')
          this.getAdjustedTrips();
        }
      });
  }

  // OK
  bankedTrips() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      bankStatus: "banked",
    };

    this.assignTripService
      .bankedTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Banked the Trip Successfully', 'success', 'OK')
          this.getAdjustedTrips();
        }
      });
  }

  // Adjust Odometer
  showOdometerModal(trip) {
    this.odomterModalObj = trip;
  }

  onSaveOdometer(evt) {
    this.dataList.forEach((item, i) => {
      if (item._id === evt._id) {
        this.dataList[i].odometerBegin = evt.odometerBegin;
        this.dataList[i].odometerStart = evt.odometerStart;
        this.dataList[i].odometerStop = evt.odometerStop;
      }
    });
    this.odomterModalObj = null;
  }

  // Signature
  showSignatureModal(trip) {
    this.signatureModalObj = trip;
  }

  onSaveSignature(data) {
    if (data) {
      this.signatureModalObj.signatureImage = data + "?" + Math.random();
      // sweetAlert('Success', 'Signature Generated', 'success', 'OK');
      const payload = {
        isEmpty: false,
        dataUrl: data,
      };
      this.assignTripService
        .generateSignature(payload, this.signatureModalObj._id)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe((data) => {
          if (data) {
            const filteredSignature = this.filteredAdjustedTrips.find((item) => item._id === this.signatureModalObj._id)
            filteredSignature.signatureImage = data.signatureImage;
            this.signatureModalObj.signatureImage = data.signatureImage;
            this.signatureModalObj = null;
          }
        });
    }
  }

  getBroker(key) {
    return getBrokersList[key];
  }

  // Banked
  bankedSingleTrip(assign, status) {
    this.popupAssignTrip = JSON.parse(JSON.stringify(assign));
    this.bankedType = status;
    // tslint:disable-next-line: max-line-length
    this.alertMessage =
      assign.bankStatus === "banked"
        ? "Are you sure you want to appeald against this trip ?"
        : "Are you sure you want to bank this trip ?";
    const object = {
      type: "adjustedtriplogs",
      _ids: [this.popupAssignTrip._id],
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      bankStatus: this.bankedType,
      statusType: "single",
    };
    this.assignTripService
      .bankedTrips(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', `Trip ${this.bankedType === 'banked' ? 'Banked': 'Appealed'} Successfully`, 'success', 'OK');
          this.selectedTrips = [];
          this.selectedTripJobIds = [];
          this.getCorporateUsers();
          this.getAdjustedTrips();
        }
      });
  }

  bankedMultipalTrips() {
    this.alertMessage = "Are you sure you want to bank these trips ?";
  }
  // Signature

  updateTripSignature(assign) {
    this.signaturePad.clear();
    this.popupAssignTrip = JSON.parse(JSON.stringify(assign));
  }

  generateSignature() {
    const object = {
      isEmpty: false,
      dataUrl: this.signaturePad.toDataURL(),
    };
    this.processSignature(object, this.popupAssignTrip._id);
  }

  processSignature(obj, id) {
    this.assignTripService
      .generateSignature(obj, id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          // sweetAlert('Success', 'Signature Generated', 'success', 'OK');
          const splitArray = data.signatureImage.split("/");
          const splitArrayTwo = splitArray[6].split(".");
          this.dataList.filter((item2) => {
            if (item2._id === splitArrayTwo[0]) {
              item2.signatureImage = data.signatureImage;
            }
          });
        }
      });
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  btnNagtiveResponse() {
    this.popupAssignTrip = JSON.parse(JSON.stringify({}));
    this.alertMessage = "";
  }
  // Methods will stay

  showFilter() {
    this.isShowFilter = !this.isShowFilter;
  }

  navigateToAdjustment(id) {
    const queryParams = { isFromBilling: true };
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/trips/${id}/adjust`], { queryParams })
    );
    window.open(url, "_blank");
    // this.router.navigate([`/trips/${id}/adjust`], { queryParams } );
  }

  async modivcareReport() {
    this.modivcareTripLog.isLoading = true;
    let sortedTrips = this.getSelectedTrips().sort(
      (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    );

    if (sortedTrips && sortedTrips.length) {
      await this.modivcareService.getModivcareReport(sortedTrips, this.user, sortedTrips[0].driver, this.fleet, this.modivcareTripLog);
    }
  }

  async downloadTripLog() {
    this.isTripLogLoader.isLoading = true;
    let sortedTrips = this.getSelectedTrips().sort(
      (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    );

    if (sortedTrips && sortedTrips.length) {
      await this.modivcareService.getTripLog(sortedTrips, this.user, sortedTrips[0].driver, this.fleet, this.isTripLogLoader, this.selectedCorporateUser);
    }
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preFleet = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          // this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {


    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          // this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  downloadForm837Reportv2() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const payload = {
      _ids: selectedTripIds,
      // clientId: selectedMemberId.clientId,
      fundingSourceName: this.preCorporate[this.selectedCorporateId].displayName
    }

    this.assignTripService.get837FromReportv2(payload).subscribe(data => {
      if (data) {
        let name = data.fileName;
        let url = urls.REPORT_SERVER_URL + "/excel/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  openParamountModal(){
  this.paramountLoader.isModal = true;
}

  downloadForm837Report() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const payload = {
      _ids: selectedTripIds,
      // clientId: selectedMemberId.clientId,
      fundingSourceName: this.preCorporate[this.selectedCorporateId].displayName
    }

    this.assignTripService.get837FromReport(payload).subscribe(data => {
      if (data) {
        let name = data.fileName;
        let url = urls.REPORT_SERVER_URL + "/excel/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  group(isNotFromButton?) {
    if (this.filteredAdjustedTrips && this.filteredAdjustedTrips.length) {
      if (!isNotFromButton) {
        this.orderBy =
          this.orderBy === "scheduleTime"
            ? "priorityClient.displayName"
            : "scheduleTime";
      }
      if (this.orderBy === "priorityClient.displayName") {
        this.filteredAdjustedTrips.sort((a, b) =>
          a.priorityClient.displayName.localeCompare(
            b.priorityClient.displayName
          )
        ); // ASC
      } else {
        this.filteredAdjustedTrips.sort(
          (a, b) =>
            <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
        );
      }
    }
  }

  showActionButtons(idx) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  callthecarInvoice() {
    if (this.selectedTrips.length) {
      const selectedTripsObj = this.dataList.filter(trip => this.selectedTrips.includes(trip._id));
      this.csvService.downloadCTCInvoice(this.dateRange[0], selectedTripsObj, this.preFleet, this.user, this.timeZone);
    } else {
      return;
    }
  }

  cms1500Report() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const { _id, displayName, email, contactNumber, address } = this.preCorporate[this.selectedCorporateId];

    const cooperatePayload = {
      _id,
      displayName,
      email,
      contactNumber,
      address,
      billingName: this.preCorporate[this.selectedCorporateId].billingName,
      mailingAddress: this.preCorporate[this.selectedCorporateId].mailingAddress,
    };

    const payload = {
      _ids: selectedTripIds,
      cooperate: cooperatePayload
    }
    this.assignTripService.getCMS1500Report(payload).subscribe(data => {
      if (data) {
        let name = data.fileName;
        let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  invoiceCSV() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

    const { _id, displayName, email, contactNumber, address } = this.preCorporate[this.selectedCorporateId];

    const cooperatePayload = {
      _id,
      displayName,
      email,
      contactNumber,
      address,
      billingName: this.preCorporate[this.selectedCorporateId].billingName,
      mailingAddress: this.preCorporate[this.selectedCorporateId].mailingAddress,
    };

    const payload = {
      _ids: selectedTripIds,
      cooperate: cooperatePayload
    }
    this.assignTripService.getInvoiceCSV(payload).subscribe(data => {
      if (data) {
        let name = data.excelName;
        let url = urls.REPORT_SERVER_URL + "api/download/excel/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  mileageInvoiceCSV() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

   const { _id, displayName, email, contactNumber, address } = this.preCorporate[this.selectedCorporateId];
   const memberId =  this.dataList.find(dt => dt.priorityClient.displayName === this.selectedMember).client;

    const cooperatePayload = {
      _id,
      displayName,
      email,
      contactNumber,
      address,
      billingName: this.preCorporate[this.selectedCorporateId].billingName,
      mailingAddress: this.preCorporate[this.selectedCorporateId].mailingAddress,
    };

    const payload = {
      _ids: selectedTripIds,
      cooperate: cooperatePayload,
      memberId
    }
    this.assignTripService.getMileageInvoiceCSV(payload).subscribe(data => {
      if (data) {
        let name = data.excelName;
        let url = urls.REPORT_SERVER_URL + "api/download/excel/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }

  // Member Log sheet v2
  mileageInvoiceCSV2() {

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

   const { _id, displayName, email, contactNumber, address } = this.preCorporate[this.selectedCorporateId];
   const memberId =  this.dataList.find(dt => dt.priorityClient.displayName === this.selectedMember).client;

    const cooperatePayload = {
      _id,
      displayName,
      email,
      contactNumber,
      address,
      billingName: this.preCorporate[this.selectedCorporateId].billingName,
      mailingAddress: this.preCorporate[this.selectedCorporateId].mailingAddress,
    };

    const payload = {
      _ids: selectedTripIds,
      cooperate: cooperatePayload,
      memberId
    }
    this.assignTripService.getInvoiceCSV2(payload).subscribe(data => {
      if (data) {
        let name = data.excelName;
        let url = urls.REPORT_SERVER_URL + "api/download/excel/" + name;
        downloadFile(url, "", name);
      }
    }, err => {
      sweetAlert("Error", err, "error", "Ok");
    })
  }


  async downloadCoTripReport() {
    this.coReportLoader.isLoading = true;
    let trips;
    let groupedTrips = {}
    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();

    for (let trip of trips) {
      groupedTrips[trip.tripId] = {
        ...trip,
      };
    }
    await this.reportService.getCoTripReport(groupedTrips, this.user, this.searchDate, this.coReportLoader, this.preFleet);
  }

   async downloadCoTripLog() {
    this.isColoradoReport.loader = true;
    let trips;
    let groupedTrips = {}
    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();

    // for (let trip of trips) {
    //   groupedTrips[trip.tripId] = {
    //     ...trip,
    //   };
    // }
    await this.reportService.getColoradoTripLog(trips, this.user, this.searchDate, this.isColoradoReport, this.preFleet, this.preLevelOfServices, this.preSpaceTypes);
  }


  calculateFare(miles, prevMiles, prevTotal) {
    let total = 0;
    if (!prevMiles) {
      if (miles <= 20) {
        total = 50;
      }

      if (miles > 20) {
        let extraMiles = miles - 20;
        total += 50 + extraMiles * 1.5;
      }
    } else {
      if (miles <= 20) {
        total = 50;
      }

      if (miles > 20) {
        let extraMiles = miles - 20;
        total += 50 + extraMiles * 1.5;
      }
    }

    return prevTotal ? prevTotal + total : total;
  }


  tripsSummary() {
    let trips = {};

    for (let trip of this.getSelectedTrips()) {
      if (trips[trip.priorityClient.displayName]) {
        trips[trip.priorityClient.displayName] = {
          miles: trips[trip.priorityClient.displayName].miles + trip.milage,
          legs: trips[trip.priorityClient.displayName].legs + 1,
          total:
            trips[trip.priorityClient.displayName].total +
            trip.preSpecialRate,
        };
      } else {
        trips[trip.priorityClient.displayName] = {
          miles: trip.milage,
          legs: 1,
          total: trip.preSpecialRate,
        };
      }
    }

    let date = this.searchDate;

    if (this.jobType === "cooperate") {
      date = this.dateRange;
    }

    const table = [
      [
        (this.user.company
          ? this.user.company.displayName
          : this.user.displayName) || "",
        " ",
        " ",
        " ",
        date && typeof date !== "string"
          ? moment(date[0]).tz(this.user.timeZone).format("MM/DD/YY") +
          " - " +
          moment(date[1]).tz(this.user.timeZone).format("MM/DD/YY")
          : moment(date).tz(this.user.timeZone).format("MM/DD/YY"),
        " ",
      ],
      [" ", " ", " ", " ", " ", " "],
      ["First Name", "Last Name", "Miles", "Legs", "$", "Per Trip"],
    ];

    let miles = 0;
    let total = 0;
    let legs = 0;

    for (let key in trips) {
      const t = [
        key.split(" ")[0],
        key.split(" ")[1] ? key.split(" ")[1] : "",
        trips[key].miles.toFixed(2),
        trips[key].legs,
        "$ " + trips[key].total,
        "$ " + (trips[key].total / trips[key].legs).toFixed(2),
      ];

      miles = miles + trips[key].miles;
      total = total + trips[key].total;
      legs = legs + trips[key].legs;

      table.push(t);
    }
    table.push([" ", " ", " ", " ", " ", " "]);

    table.push([
      " ",
      " ",
      miles.toFixed(2),
      legs,
      "$ " + total,
      " ",
    ]);

    exportToCsv(`trips-summary-${moment().format("MM-DD-YYYY")}.csv`, table);
  }

  async ahcccsReport() {
    this.isAHCCCSFile = true;
    let trips = {};

    for (let trip of this.getSelectedTrips()) {
      // if (trips[trip.priorityClient.displayName]) {
      //   trips[trip.priorityClient.displayName].push(trip)
      // } else {
      //   trips[trip.priorityClient.displayName] = [trip]
      // }
      const date = moment(trip.scheduleTime)
        .tz(this.user.timeZone)
        .format("MM-DD-YYYY");
      if (trips[date]) {
        if (trips[date][trip.priorityClient.displayName]) {
          trips[date][trip.priorityClient.displayName].push(trip);
        } else {
          trips[date][trip.priorityClient.displayName] = [trip];
        }
      } else {
        trips[date] = { [trip.priorityClient.displayName]: [trip] };
      }
    }

    for (let myDate in trips) {
      for (let trip in trips[myDate]) {
        await this.cms1500Service.ahcccsReport(
          myDate,
          trips[myDate][trip],
          this.user
        );
      }
    }
    this.isAHCCCSFile = false;
  }

  downloadDriverLog() {
    let sortedTrips = this.getSelectedTrips();
    //.sort(
    //   (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    // );

    this.driverLoader.isLoading = true;
    this.driverLogService.dailyDriverLog(
      sortedTrips,
      this.user,
      this.driverLoader
    );
  }
  downloadMemberLog() {
    this.memberLoader.isLoading = true;
    let sortedTrips = this.getSelectedTrips().sort(
      (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    );

    let tripsGroupedByDate = {};
    sortedTrips.forEach((trip) => {
      let dateKey = moment(trip.scheduleTime).format("YYYY/MM/DD");

      tripsGroupedByDate[dateKey] = tripsGroupedByDate[dateKey] || {
        trips: [],
      };
      tripsGroupedByDate[dateKey].trips.push(trip);
    });
    this.memberLogService.dailyMemberLog(
      tripsGroupedByDate,
      this.user,
      this.memberLoader,
      this.selectedCorporateUser
    );
  }


  downloadCompletedReport() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date:
        moment(this.dateRange[0]).format("MM/DD/YYYY") +
        " - " +
        moment(this.dateRange[1]).format("MM/DD/YYYY"),
      trips,
      // corporate: this.selectedCooperate,
      // driver: this.selectedDriver,
      // vehicle: this.selectedVehicle,
      timezone: this.timeZone,
    };
    // return;
    this.csvService.generateCompletedTripReport(data);
  }

  async resubmissionFormReport() {
    let sortedTrips = this.getSelectedTrips().sort(
      (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
    );

    if (sortedTrips && sortedTrips.length) {
      await this.modivcareService.getResubmissionReport(sortedTrips, this.user, sortedTrips[0].driver, this.tempVin, this.dateRange[0],this.preSpaceTypes);
    }
  }

  prodCheck() {
    if (this.isProduction) {
      const companyId = this.user.company ? this.user.company._id : this.user._id
      if (companyId === '6463be83c60e5d659486581f') {
        return true;
      } else {
        return false;
      }

    }
    else {
      return true
    }
  }

  async downloadPatientReport(){

    let selectedTripIds;
    if (!this.selectedTrips.length) {
      selectedTripIds = this.dataList.map((trip) => trip._id);
    }
    else {
      selectedTripIds = this.getSelectedTrips().map((trip) => trip._id)
    }

   const { _id, displayName, email, contactNumber, address } = this.preCorporate[this.selectedCorporateId];
   const memberId =  this.dataList.find(dt => dt.priorityClient.displayName === this.selectedMember).client;

    const cooperatePayload = {
      _id,
      displayName,
      email,
      contactNumber,
      address,
      billingName: this.preCorporate[this.selectedCorporateId].billingName,
      mailingAddress: this.preCorporate[this.selectedCorporateId].mailingAddress,
    };

    const payload = {
      _ids: selectedTripIds,
      cooperate: cooperatePayload,
      memberId
    }
    this.assignTripService.getInvoiceCSV2(payload).subscribe(data => {
      if (data) {
        this.reportService.getMBMReport(data.workSheets[0], this.selectedMember);

      }
    })
  }


  mtmClaimFile() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date: moment(this.dateRange[0]).format("MM/DD/YYYY") + " - " + moment(this.dateRange[1]).format("MM/DD/YYYY"),
      trips,
      timezone: this.timeZone,
      preFleet : this.preFleet
    };
    this.csvService.downloaMTMClaimFile(data);
  }

  mtmClaimFileV2() {
    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();


    const data = {
      date: moment(this.dateRange[0]).format("MM/DD/YYYY"),
      trips,
      timezone: this.timeZone,
      preFleet : this.preFleet
    };
    this.csvService.downloaMTMClaimFileV2(data);
  }

  async downloadMTMDriverLog(){

    let trips;

    if (!this.selectedTrips.length)
      trips = this.dataList;
    else
      trips = this.getSelectedTrips();
    this.reportService.getMTMDriverLog(trips , this.user);
  }


  access2CareDriverLog() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime:  this.dateRange[0],
      companyImage: this.companyImage
    }

    this.assignTripService
      .access2CareDriverLog(this.selectedDriver, payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          let name = data.pdfName;
          let url = urls.BASE_REPORT_SERVER_URL + 'download/pdf/' + name;
          downloadFile(url, '', name);
        }
      });
  }

  mtmAllDriverLogs(singleDriver:boolean) {
    let payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime:  this.dateRange[0],
      companyImage: this.companyImage
    } as any;
    if(singleDriver){
      payload.driver = this.selectedDriver
    }


    this.assignTripService
      .donwloadAllDriverLog(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          let name = data.pdfName;
          let url = urls.BASE_REPORT_SERVER_URL + 'download/pdf/' + name;
          downloadFile(url, '', name);
        }
      });
  }

  // single driver log
  // mtmDriverLog() {
  //   const payload = {
  //     type: this.status,
  //     _ids: this.selectedTrips,
  //     scheduleTime: this.todayDate,
  //     companyImage: this.companyImage,
  //     driver : this.selectedDriver
  //   }

  //   this.assignTripService
  //     .donwloadDriverLog(payload)
  //     .pipe(takeUntil(componentDestroyed(this)))
  //     .subscribe(data => {
  //       if (data) {
  //         let name = data.pdfName;
  //         let url = urls.BASE_REPORT_SERVER_URL + 'download/pdf/' + name;
  //         downloadFile(url, '', name);
  //       }
  //     });
  // }


  downloadCorporateInvoice2() {
    const selectedCorporate = this.corporateUsers.find(corporate => corporate._id === this.selectedCorporateUser._id);
    this.corporateLoader.isLoading = true;
    let sortedTrips = this.getSelectedTrips();
    this.corporateReportService.getCorporateReport(
      sortedTrips,
      this.user,
      selectedCorporate,
      this.dateRange,
      this.corporateLoader,
      this.preSpaceTypes
    );
  }

  manifestLogistic() {
    const payload = {
      tempVin: this.tempVin,
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.dateRange[0],
      companyImage: this.companyImage,
    };

    this.assignTripService
      .donwloadLogisticareManifest(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          let name = data.pdfName;
          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + name;
          downloadFile(url, "", name);
        }
      });
  }
  claimFile(isPuDo) {
    const payload = {
      isPuDo: isPuDo,
      tempVin: this.tempVin,
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.dateRange[0],
      companyImage: this.companyImage,
    };

    this.assignTripService
      .claimFile(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          let name = data.excelName;
          let url = urls.REPORT_SERVER_URL + "excel/" + name;
          downloadFile(url, "", name);
        }
      });
  }
  mtmClaim() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime:this.dateRange[0],
      companyImage: this.companyImage,
    };

    this.assignTripService
      .donwloadMtmClaim(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          let name = data.excelName;
          let url = urls.REPORT_SERVER_URL + "excel/" + name;
          downloadFile(url, "", name);
        }
      });
  }

  callthecarInvoicev2() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.dateRange[0],
      companyImage: this.companyImage,
    };
    this.assignTripService
      .donwloadCallTheCarInvoice(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          let name = data.excelName;
          let url = urls.REPORT_SERVER_URL + "excel/" + name;
          downloadFile(url, "", name);
        }
      });
  }

  billedtomodivcare() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
    };

    this.assignTripService
      .billedToModivcare(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.dataList.forEach((assign) => {
            const assignIndex = this.selectedTrips.indexOf(
              assign._id.toString()
            );
            if (assignIndex > -1) {
              assign.bankStatus = "banked";
              assign.isSelected = false;
              this.selectedTrips.splice(assignIndex, 1);
            }
          });
        }
      });
  }

  RepushToCTC() {
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
    };

    this.assignTripService
      .rePushToCTC(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.dataList.forEach((assign) => {
            const assignIndex = this.selectedTrips.indexOf(
              assign._id.toString()
            );
            if (assignIndex > -1) {
              assign.bankStatus = "banked";
              assign.isSelected = false;
              this.selectedTrips.splice(assignIndex, 1);
            }
          });
        }
      });
  }

  corporateInvoiceReport() {
    let payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
    };

    if (this.dateRange && this.dateRange.length) {
      payload["startDate"] = this.dateRange[0];
      payload["endDate"] = this.dateRange[1];
    }

    this.assignTripService
      .donwloadCorporateInvoiceReport(this.selectedCorporateId, payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          let name = data.pdfName;
          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + name;
          downloadFile(url, "", name);
        }
      });
  }

  corporateInvoice() {
    // Corporate TRF
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
    };

    this.assignTripService
      .donwloadCorporateInvoice(this.selectedCorporateId, payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          let name = data.pdfName;
          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + name;
          downloadFile(url, "", name);
        }
      });
  }

  async memberTripsLogHHT(fileName?) {
    this.isMemberTripsLogDownloading = true;

    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
      cooperate: this.selectedCorporateUser,
    };

    this.assignTripService
      .memberTripsLogHHT(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(async (data) => {
        if (data) {
          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + data.pdfName;
          downloadFileAsBlob(url, fileName ? fileName : data.pdfName);
          this.isMemberTripsLogDownloading = false;
        }
      });
    }

    // memberTripsLogHMT
  async memberTripsLogHMT(fileName?) {
    this.isTripsLogHMTLoading = true;

    const payload = {
      type: 'adjustedtriplogs',
      _ids: this.selectedTrips,
      scheduleTime: this.dateRange[0],
      companyImage: this.selectedCorporateUser ? this.selectedCorporateUser.profileImageURL : ''
    };

    this.assignTripService
      .memberTripsLogHMT(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(async (data) => {
        if (data) {
          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + data.pdfName;
          downloadFileAsBlob(url, fileName ? fileName : data.pdfName);
          this.isTripsLogHMTLoading = false;
        }
      });
    }

    async memberTripsLog(fileName?) {
      this.isMemberMBRloading = true;

    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
    };

    this.assignTripService
      .memberTripsLog(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(async (data) => {
        if (data) {

          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + data.pdfName;
          downloadFileAsBlob(url, fileName ? fileName : data.pdfName);
          this.isMemberMBRloading = false;
        }
      });
  }

  cameraTripsLog() {
    this.isMemberFile = true;
    const payload = {
      type: this.status,
      _ids: this.selectedTrips,
      scheduleTime: this.searchDate,
      companyImage: this.companyImage,
    };

    this.assignTripService
      .cameraTripslog(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.isMemberFile = false;
          let name = data.pdfName;
          let url = urls.REPORT_SERVER_URL + "api/download/pdf/" + name;
          downloadFile(url, "", name);
        }
      });
  }

  ngOnDestroy(): void { }
}
